import { useState } from 'react';
import SafeIcon from './SafeIcon';
import { useApp } from '../i18n/AppContext';

const backdropStyle = {
  position: 'fixed',
  inset: 0,
  background: '#050914B8',
  zIndex: 80,
  display: 'grid',
  placeItems: 'center',
  padding: 16,
} as const;
const dialogCardStyle = { maxWidth: 440, width: '100%', background: 'var(--amy-surface)' } as const;

export function CommentDialog({
  onSave,
  onCancel,
}: {
  onSave: (text: string) => void;
  onCancel: () => void;
}) {
  const { translate } = useApp();
  const [text, setText] = useState('');
  return (
    <div
      style={backdropStyle}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onCancel();
      }}
    >
      <section className="panel" role="dialog" aria-modal="true" style={dialogCardStyle}>
        <h2>{translate('Add a comment')}</h2>
        <textarea
          className="text-field"
          rows={4}
          autoFocus
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder={translate('Write a note about this post')}
        />
        <div className="button-row" style={{ marginTop: 12 }}>
          <button
            className="button primary"
            disabled={!text.trim()}
            onClick={() => onSave(text.trim())}
          >
            <SafeIcon name="FiCheck" />
            {translate('Save comment')}
          </button>
          <button className="button" onClick={onCancel}>
            {translate('Cancel')}
          </button>
        </div>
      </section>
    </div>
  );
}
